/* decommission 
import termsBodykeyPP from '../views/amwayterms/termsBodykeyPP'
import termsBodykeyTC from '../views/amwayterms/termsBodykeyTC'
import termsBodykeyPIM from '../views/amwayterms/termsBodykeyPIM'
import termsBodykeyPIC from '../views/amwayterms/termsBodykeyPIC'
import termsBodykeySI from '../views/amwayterms/termsBodykeySI'
import termsBodykeySIO from '../views/amwayterms/termsBodykeySIO'
import termsBodykeySIP from '../views/amwayterms/termsBodykeySIP'
import termsBodykeyPIP from '../views/amwayterms/termsBodykeyPIP'
*/

import termsAbo from '../views/amwayterms/termsAbo'
import termsMember from '../views/amwayterms/termsMember'
import termsCustomer from '../views/amwayterms/termsCustomer'
import termsClubtaola from '../views/amwayterms/termsClubtaola'
import termsBasksop from '../views/amwayterms/termsBasksop'

export default [
    {
      path: '/abo/abo_terms',
      name: 'termsAbo',
      component: termsAbo
    },
    {
      path: '/member/member_terms',
      name: 'termsMember',
      component: termsMember
    },
    {
      path: '/customer/customer_terms',
      name: 'termsCustomer',
      component: termsCustomer
    },
    {
      path: '/terms/abo',
      name: 'termsAbo',
      component: termsAbo
    },
    {
      path: '/terms/member',
      name: 'termsMember',
      component: termsMember
    },
    {
      path: '/terms/customer',
      name: 'termsCustomer',
      component: termsCustomer
    },
    {
      path: '/terms/clubtaola',
      name: 'termsClubtaola',
      component: termsClubtaola
    },
    {
      path: '/terms/basketsop',
      name: 'termsBasketsop',
      component: termsBasksop
    },
  ]


// WEBPACK FOOTER //
// ./src/router/amwayterms.js